import React, { useEffect, useContext, useState } from 'react';
import { createPortal } from 'react-dom';
import { style } from '../../utils/image';
import { ThemeContext } from '../../store/ThemeProvider';
import NormalButton from './NormalButton';
import stat from '../../utils/stat';
import { IOneButton } from './AllForPendant';
import ComponentLink from '../ComponentLink';
import { formatImage } from '../../utils/util';
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

interface ICustomButton extends IOneButton {
  // rootStore?:RootStore;
  children?:any;
}

const modalRef = window.document.createElement('div');
modalRef.className = 'pendant-modal-portal';

const CustomButton = (props: ICustomButton) => {
  const { type, image, link } = props;
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) {
      window.document.body.appendChild(modalRef);
    }

    return () => {
      if (modalRef && modalRef.parentNode) {
        window.document.body.removeChild(modalRef);
      }
    };
  }, [visible]);

  const renderModal = () => {
    if (link && link.modalcontent) {
      return createPortal(
        <div className={'pendent-modal show'}>
          <div className="wrapper">
            <img
              src={style(link.modalcontent, 'wx_560_n')}
              style={{ userSelect: 'auto' }}
              onClick={() => {
                if (link.modallink) {
                  window.location.href = link!.modallink;
                }
              }}
            />
          </div>
          <div
            className="close"
            onClick={() => {
              setVisible(false);
              clearAllBodyScrollLocks();
            }}
          >
            <img src={require('../../assets/x-white.png')} />
          </div>
        </div>,
        modalRef
      );
    }
  };

  useEffect(()=>{
    if(link && link.modalauto && link.type == 'modal-image') {
      let shouldShow = true;
      let localShow = window.localStorage.getItem(
        `modal_content_${link.modalcontent}`
      );
      if (localShow) {
        if (Number(localShow) > Date.now()) {
          shouldShow = false;
        }
      }

      if (shouldShow) {
        setVisible(true);
        disableBodyScroll(window.document.body);

        window.localStorage.setItem(
          `modal_content_${link.modalcontent}`,
          String(Date.now() + 86400 * 1000)
        );
      }
    }
  }, [link && link.modalauto && link.type == 'modal-image']);

  return (
    <>
      <NormalButton
        className="pendant-custom"
        onClick={() => {
          if (link) {
            if (link.type == 'show_lucky') {
              let event = new Event('lucky_popup');
              event.data = link.value;
              window.dispatchEvent(event);
            } else if (link.type == 'modal-image') {
              setVisible(true);
              disableBodyScroll(window.document.body);
            } else {
              ComponentLink.to(link);
            }
          }

          stat.event('button_custom');
        }}
      >
        {props.children ? props.children : (image ? <img src={style(image, 'wx_icon_80')} /> : null)}
      </NormalButton>
      {visible ? renderModal() : null}
    </>
  );
};

export default CustomButton;
